import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../../../lib/ng2-sapmp/src/providers';
import { BreadCrumbModel, BreadCrumbService } from '../../../../lib/ng2-sapmp/src/ui-components/breadcrumb';
import { CareComponentService } from '..';
import { PageLoaderService } from '../../../../lib/ng2-sapmp/src/ui-components/page-loader';
import { GridOptionsModel,  } from 'lib/ng2-sapmp/src/ui-components/custom-grid/shared/model/grid-options.model';

@Component({
  selector: 'app-whiteListsAdmin',
  templateUrl: './whiteListsAdmin.component.html',
  styleUrls: ['./whiteListsAdmin.component.scss'],
  providers: [CareComponentService]
})
export class whiteListsAdminComponent implements OnInit {
  setupError = false;
  rowData : any;
  columnDefs : any;
  data: any;
  dmpWhitelistFansData: any;
  inputSlot: any = '';
  inputData : any;
  isDisabled : boolean;
  gridOptions: any;
  dmp_id : string;
  formSuccess = false;
  submitting = false;
  showError: boolean;
  successMessage: string;
  errorMessage: string;
  private gridApi;
  private gridColumnApi;

  constructor(
    private breadcrumb: BreadCrumbService,
    private router: Router,
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    private careService: CareComponentService,
    private pageloaderService: PageLoaderService
  ) { }

  ngOnInit(): void {
    this.inputSlot = "";
    this.isDisabled = true;
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.pageloaderService.setPageLoaderStatus(false);
    this.dmpWhitelistFansData = this.route.snapshot.data.pageData.caredmpWhitelistFans;
    this.pageLoad();
    this.initGrid();
    this.columnDefs = this.dmpWhitelistFansData.columnDefinitions;
    }

    initGrid(){
    let data = {
      "queryString": "[{\"$match\":{\"_id\":{$exists:true}}}]"
    }
    this.careService.getDMPWhitelistFans(data).subscribe(response => {
      if (response !== null){
        var tableData = []; 
        let dmpFansList = response.map((data)=> {return data.dmpFans})
        let id = response.map((data)=> {return data._id})
        this.dmp_id= id[0].$oid
        let fansList = dmpFansList[0]
        let len = dmpFansList[0].length
        for(var i=0; i<len; i++){
          var obj = { "FanID": fansList[i]};
         // console.log(obj,'obj')
          tableData.push(obj);
         }
        this.rowData = tableData.reverse()
        }
      this.pageloaderService.setPageLoaderStatus(true);
    },error => {
        console.log(error);
    });
  }

  pageLoad() {
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.label = this.dmpWhitelistFansData.fanBreadcumb;
    breadcrumb.routerLink = this.dmpWhitelistFansData.fanBreadcumb;
    this.breadcrumb.setCurrentBreadCrumb(breadcrumb);
  }

  keyValidation(event) {
    let value  = event.target.value.replace(/\s/g, "")
    var specialChars = /[`!@#$%^&*()_+\-=\[\]{};'.:"\\|,<>\/?~]/;
    if(value.length === 8){
      this.isDisabled= false
      // this.formSuccess= false
      // this.successMessage = ''
    }
    if(value.length <8 ){
      this.isDisabled = true;
    }
    if ((value.length > 0)  &&( value.length<=8) &&
    (parseInt(value)) && (!specialChars.test(value))) {  
      this.inputSlot = value;
      this.inputData= value;
      this.setupError= false;
    }
    else {
      this.inputSlot = "";
      this.setupError = true;
      this.isDisabled= true;
    }
  }

  handleError(error) {
    if (error) {
        this.showError = true;
        this.errorMessage = this.dmpWhitelistFansData.generalError;
    }
  }
  submitRequest(){
    this.formSuccess = false;
     let stringDmp = "dmpFans"
     let payloadData = `{ "${stringDmp}": "${this.inputData.toString()}"}`;
    let dmpId = this.dmp_id.toString()
    let duplicateFanValue = this.rowData.filter((data)=>{ 
      return data.FanID.toString() === this.inputData.toString()
    });
    if(duplicateFanValue.length >0){
      this.inputSlot = "";
      this.setupError = true;
      this.isDisabled= true;
      this.formSuccess = false;
    }
    if( duplicateFanValue.length === 0 ){
    this.careService.getSavedDmpwhitelist(dmpId, payloadData).subscribe(() => {
    this.ngOnInit();
    this.utilityService.loadFocusOnTop();
    this.formSuccess = true;
    this.successMessage = this.dmpWhitelistFansData.successMerge;
   // this.router.navigate(['care/home']);
  }, error => {
    this.formSuccess = false;
    this.handleError(error);
    this.utilityService.loadFocusOnTop();
      });
    }
  // this.resetRowData();
  }

  // resetRowData = () => {
  //   this.gridOptions.api.refreshView();
  // };

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  }
